<template>
	<div class="owl-carousel">
		<div class="item" v-for="item in items">
			<div class="containerItem3">
				<div class="left">
					<div :style="{ 'background-image' : 'url(' + item.img + ')' }" class="img"></div>
				</div>
				<div class="right">
					<div class="contentContainer">
						<div class="textHidden">
							<div class="header">
								{{item.header}}
							</div>
							<div class="text">
								{{item.text}}
							</div>
						</div>
						<div>
							<a :href="item.href" class="button waves-effect waves-light">{{item.button}}</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
module.exports = {

	props: ['items'],

	data () {
		return {}
	},

	updated() {
		this.$emit('updated', {
			owlSettings: {
				items: 1,
				loop: this.items.length > 1 ? true : false,
				nav: true,
				dots: true,
				margin: 30
			}
		});
	}
}
</script>

<style lang="scss">
@import "scss/wanted";

.slider-lastProject {
	margin-bottom: 85px;
	b{
		font-family: $ProximaNova_bold;
	}
	.owl-carousel {
		position: relative;
		padding-bottom: 70px;
		.owl-stage-outer{
			padding: 0 1px;
		}
		.item {
			.containerItem3{
				display: flex;
				flex-direction: column;
				@include m___up{
					flex-direction: row;
				}
				& > *{
					width: 100%;
				}
				.left{
					border-radius: 8px;
					position: relative;
					overflow: hidden;
					height: 305px;
					@include l_up{
						height: 305px;
					}
					@include l__up{
						min-width: 519px;
					};
					.img{
						margin: 2px;
						position: absolute;
						top: 0;
						bottom: 0;
						left: 0;
						right: 0;
						margin: 0 auto;
						width: 100%;
						height: 100%;
						background-position: center;
						background-size: cover;
						border-radius: 8px;
					}
				}
				.right{
					padding-left: 0px;
					padding-top: 30px;
					@include m___up{
						padding-left: 28px;
						padding-top: 0px;
						&:after{
							top: calc(50% - 9px);
							left: -12px;
						}
					}
					.contentContainer{
						padding: 23px 30px 34px;
						border: 1px solid #e2edf3;
						margin: 2px;
						border-radius: 8px;
						position: relative;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						@include m___up{
							height: 305px;
						}
						.textHidden{
							height: 245px;
							overflow: hidden;
							@include s___up{
								height: 200px
							}
							@include m___up{
								height: 150px;
								overflow: hidden;
							}
							.header{
								font-family: $ProximaNova_bold;
								font-size: rem(15);
								line-height: rem(24);
								margin-bottom: 21px;
								color: #000000;
							}
							.text{
								font-size: rem(14);
								line-height: rem(20);
								color: #000000;
							}
						}
						&:after{
							content: "";
							position: absolute;
							top: -12px;
							left: calc(50% - 6px);
							width: 12px;
							height: 18px;
							background-image: url('../img/arrow.jpg');
							background-size: cover;
							transform: rotate(90deg);
							@include m___up{
								left: -10px;
								top: calc(50% - 9px);
								transform: rotate(0deg);
							}
						}
					}
				}
				.button{
					text-decoration: none;
					border-radius: 50px;
					min-height: 43px;
					height: 43px;
					width: 190px;
					padding: 0 25px;
					display: inline-flex;
					justify-content: center;
					align-items: center;
					margin-top: 23px;
					font-size: rem(16);
					@include single-transition();
					margin-right: 30px;
					border-width: 1px;
					border-style: solid;
					&:hover{
						color: white;
					}
				}
			}
		}
		.owl-dots{
			position: absolute;
			display: flex;
			align-items: center;
			height: 30px;
			width: 100%;
			bottom: 0;
		}
		.owl-dots{
			justify-content: flex-strat;
			padding-bottom: 3px;
			.owl-dot{
				display: flex;
				width: 12px;
				height: 12px;
				margin-right: 10px;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				transition: 0.4s ease-in-out;
				border: 1px solid black;
				position: relative;
				span{
					transition: 0.4s ease-in-out;
					width: 6px;
					border-radius: 50%;
					height: 6px;
					background-color: transparent;
					display: inline-block;
					position: absolute;
					margin: 0 auto;
					top: calc(50% - 3px);
					left: calc(50% - 3px);
				}
				&.active{
					border-width: 1px;
					border-style: solid;
				}
			}
		}
		.owl-nav{
			font-size: 0;
			display: flex;
			justify-content:space-between;
			width: 100px;
			position: absolute;
			right: 0;
			bottom: -34px;
			z-index: 11;
			div{
				width: 42px;
				height: 42px;
				border-radius: 100%;
				@include single-transition();
				background-size: 25px;
				background-position: center;
				background-repeat: no-repeat;
				background-image: url('../img/arr.svg');
				border: 1px solid black;
				background-color: #fff;
				&:hover{
					background-image: url('../img/arr2.svg');
				}
			}
			.owl-prev{
				bottom: 30px;
				transform: rotate(90deg);
				position: relative;
				left: 0;
			}
			.owl-next{
				bottom: 30px;
				transform: rotate(-90deg);
				position: relative;
				right: 0;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// lastProject.vue?122c2c62